import { createApp } from 'vue'
import App from './App.vue'

require('halfmoon/css/halfmoon-variables.min.css')

createApp(App).mount('#app')
